module.exports = __webpack_public_path__ + "static/pic02-6192d8d333c1ad980312e26c73384937.jpg";